import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-routing-info',
  templateUrl: './routing-info.component.html',
  styleUrls: ['./routing-info.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutingInfoComponent {}
